<style lang="less">
  @import "./PositionServer.less";
</style>

<template>
  <div class="position-server">
    <div id="container"></div>
  </div>
</template>

<script>
import PositionServer from './PositionServer.js'
export default {
  ...PositionServer
}
</script>
